<template>
    <v-layout data-testid="metadata-custom-dropdown">
        <custom-dropdown
            :options="getItems"
            :label="metadata[`description${this.upperLocale}`]"
            :required="required"
            :value="value"
            :index="metadata.id"
            :id="metadata.name"
            @update:value="emitValue"
        />
    </v-layout>
</template>
<script>
import CustomDropdown from '@/components/metadata/inputs/dropdown/CustomDropdown.vue';
import { find, map, values } from 'lodash';
import { mapGetters } from 'vuex';
import config from './config.json';
import * as countries from 'i18n-iso-countries';

export default {
    components: { CustomDropdown },
    props: {
        metadata: { type: Object, required: true },
        required: { type: Boolean, required: false, default: false },
        value: { type: String, required: false, default: '' },
    },
    computed: {
        ...mapGetters({
            upperLocale: 'upperLocale',
            locale: 'locale'
        }),
        appendIcon() {
            return find(config, (c, key) => key === this.metadata.name)?.icon ?? undefined;
        },
        getItems() {
            let options = find(config, (c, key) => key === this.metadata.name)?.options ?? [];

            options = (options.length > 0) ? options.map(opt => ({ value: this.$i18n.t(opt.value) ?? opt.value, text: this.$i18n.t(opt.text) ?? opt })) : options;

            return (this.metadata.name === 'covid_screening_country') ? this.getCountriesItems : options;
        },
        getCountriesItems() {
            return map(values(countries.getNames(this.locale)), c => ({ value: c, text: c }));
        }
    },
    methods: {
        emitValue(value) {
            this.$emit('update:value', value);
        },
    },
};
</script>
